'use strict';

exports.__esModule = true;
exports['default'] = addClass;

function addClass(el, classNames) {
    if (el.classList) {
        return classNames.forEach(function (cl) {
            el.classList.add(cl);
        });
    }
    el.className += ' ' + classNames.join(' ');
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-scrollbars/lib/utils/addClass.js
// module id = 214
// module chunks = 0 1 9